import React from 'react';

import { isBrowser } from '@zapier/common-utils';
import { TrackOnChange, useTrackingContext } from '@zapier/toolbox-tracking';

let firstLoad = true;

const TrackRouting = ({ children, path }) => {
  const { trackEvent } = useTrackingContext();

  const message = firstLoad ? 'ssr rendered' : 'navigate ssr';
  firstLoad = false;

  if (!isBrowser()) {
    return React.Children.only(children);
  }

  return (
    <TrackOnChange
      track={trackEvent}
      trackingMessage={message}
      trackingProps={{ path }}
    >
      {React.Children.only(children)}
    </TrackOnChange>
  );
};

export default TrackRouting;
